import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/button";
import TextField from "../../components/textField/textField";
import { useSafeNavigate } from "../../components/unloadBlocker";
import { useAppContext } from "../../context/appContext";

export default function ChangeEmailPage() {

    const {sessionId, accountController} = useAppContext();

    const navigate = useSafeNavigate(useNavigate());

    const {id} = useParams();
    const [email, setEmail] = React.useState("");
    const [error, setError] = React.useState<string | undefined>(undefined);

    const [isLoading, setIsLoading] = React.useState(false);

    async function updateEmail() {
        if(isNaN(Number(id))) {
            window.location.href = "/error/2";
            return;
        }
        setIsLoading(true);
        await accountController.registerUpdateEmail(Number(id), {
            email: email
        }).then(() => {
            navigate("/signup/verifyEmail/" + id);
        }).catch((err: any) => {
            setError(err.response.data.message || "An error occurred while changing the email.");
        });
        setIsLoading(false);
    }


    return <div className="login-box page no-footer open-spacing">
        <div className="header column">
            <h1>Change your email here</h1>
            <p>Enter the new email you want your account to be connected with</p>
        </div>
        <div className="content">
            <TextField placeholder="Email..." label="New Email" value={email} onChange={setEmail} type="email" />
            <p className="error">{error}</p>
            <Button loading={isLoading} onClick={updateEmail}>Update Email</Button>
        </div>
    </div>;;

}